// AI Generated Component
import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'policy-priority',
    standalone: false,
    template: `
        <mon-chart-bar
            [height]="235"
            [labels]="chartLabels"
            [data]="chartData"
            [options]="chartOptions"
            [override]="chartOverrides"
            [colors]="barColors"
        >
        </mon-chart-bar>
    `,
})
export class PolicyPriorityComponent implements OnInit {
    @Input() policies: any;

    chartLabels: any;
    chartData: any;
    chartSeries: any;
    chartOptions: any;
    barColors: any;
    chartOverrides: any;

    constructor (private translateService: TranslateService) {}

    ngOnInit () {
        this.activate();
    }

    private activate () {
        this.chartLabels = [
            this.translateService.getString('High'),
            this.translateService.getString('Medium'),
            this.translateService.getString('Low'),
        ];
        this.chartData = [[this.getByPriority('high'), this.getByPriority('medium'), this.getByPriority('low')]];
        this.chartSeries = [''];
        const max = this.chartData[0].reduce(function (a: any, b: any) {
            return Math.max(a, b);
        }, 0);
        this.chartOptions = {
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-0',
                        ticks: {
                            min: 0,
                            max: max * 1.5,
                        },
                        display: false,
                        gridLines: {
                            display: false,
                        },
                    },
                ],
                xAxes: [
                    {
                        barPercentage: 1,
                        categoryPercentage: 0.5,
                        gridLines: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            fontColor: '#a6a6a6',
                            fontSize: 11,
                        },
                    },
                ],
            },
            drawLabelOnChart: true,
        };

        this.barColors = ['#a8d6f3', '#a8d6f3', '#a8d6f3'];

        this.chartOverrides = [
            {
                borderWidth: 0,
                backgroundColor: 'rgba(54, 162, 235, 0.5)',
            },
        ];
    }

    private getByPriority (priority: any) {
        return this.policies.reduce(function (num: any, policy: any) {
            if (policy.priority === priority && policy.matches_count > 0) {
                num++;
            }
            return num;
        }, 0);
    }
}
